/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_For_Companies_DescInputs */

const en_stats_for_companies_desc = /** @type {(inputs: Stats_For_Companies_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage job postings & candidates`)
};

const de_stats_for_companies_desc = /** @type {(inputs: Stats_For_Companies_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellen & Kandidat*innen verwalten`)
};

/**
* | output |
* | --- |
* | "Manage job postings & candidates" |
*
* @param {Stats_For_Companies_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const stats_for_companies_desc = /** @type {((inputs?: Stats_For_Companies_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_For_Companies_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_stats_for_companies_desc(inputs)
	return en_stats_for_companies_desc(inputs)
});